import { getApiClient } from "../../client"
import { uploadFileToS3 } from "../file"

export interface UpdateOrganizationStyleInput {
  primaryColor: string
  secondaryColor: string
}

export interface UploadOrganizationLogoToS3Params {
  presignedUrl: string
  uniqueFilename: string
}

interface OrganizationStyleApiConfig {
  baseEndpoint: string
}

export function createOrganizationStyleService(
  config: OrganizationStyleApiConfig,
) {
  const { baseEndpoint } = config

  return {
    async updateStyle({
      primaryColor,
      secondaryColor,
    }: UpdateOrganizationStyleInput) {
      const apiClient = getApiClient()

      return await apiClient
        .put(`${baseEndpoint}/style`, {
          json: {
            organizationStyle: { primaryColor, secondaryColor },
          },
        })
        .json()
    },

    async getStyleCompanyPicture() {
      const apiClient = getApiClient()

      return await apiClient
        .get<{
          data: {
            url: string
          }
        }>(`${baseEndpoint}/style/company_picture`)
        .json()
    },

    async postStyleCompanyPicture(
      displayFilename: string,
    ): Promise<UploadOrganizationLogoToS3Params> {
      const apiClient = getApiClient()
      const response = await apiClient.post(
        `${baseEndpoint}/style/company_picture`,
        {
          searchParams: {
            display_filename: displayFilename,
          },
        },
      )

      return await response.json()
    },

    async patchStyleCompanyPicture({
      displayFilename,
      uniqueFilename,
    }: {
      displayFilename: string
      uniqueFilename: string
    }): Promise<void> {
      const apiClient = getApiClient()
      await apiClient.patch(`${baseEndpoint}/style/company_picture`, {
        searchParams: {
          display_filename: displayFilename,
          unique_filename: uniqueFilename,
        },
      })
    },

    async uploadLogo(file: File): Promise<void> {
      // Step 1: Get presigned URL
      const responseData = await this.postStyleCompanyPicture(file.name)

      // Step 2: Upload file to S3
      await uploadFileToS3(file, responseData.presignedUrl)

      // Step 3: Finalize upload
      await this.patchStyleCompanyPicture({
        displayFilename: file.name,
        uniqueFilename: responseData.uniqueFilename,
      })
    },
  }
}
